import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reward_share",
  "use": "icon-reward_share-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reward_share\"><path d=\"M8 0v2H3v14h14v-5h2v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6Zm7.586 2H11V0h8v8h-2V3.414l-7 7L8.586 9l7-7Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol